import classNames from "classnames";

function DeliveryOptionCard({ title, subtitle, selected, onClick }) {
  return (
    <label
      className={classNames(
        "border rounded-lg p-3 mb-0 cursor-pointer",
        selected && "border-primary",
      )}
    >
      <input
        type="radio"
        className="visually-hidden"
        checked={selected}
        onChange={() => {}}
        onClick={onClick}
        data-testid="radio"
      />
      <p className="font-size-sm font-weight-bold text-dark mb-0">{title}</p>
      <p className="font-size-xs text-gray mb-0">{subtitle}</p>
    </label>
  );
}

export default DeliveryOptionCard;
